field1 = document.getElementById('field1')
field2 = document.getElementById('field2')
field3 = document.getElementById('field3')
field4 = document.getElementById('field4')
field5 = document.getElementById('field5')

function unlockFields() {
    if (String(field4.value != '...')) {
        field1.disabled = false
        field2.disabled = false
        field3.disabled = false
        field1.style.backgroundColor = '05AA6D'
        field2.style.backgroundColor = '05AA6D'
        field3.style.backgroundColor = '05AA6D'
    }
}

function fromRadius () {
    var radius = field1.value
    var height = field4.value
    var result = Math.PI * (radius*radius) * height

    result = Math.round(result*100)/100
    
    if (String(result) != 'Infinity' && String(result) != 'NaN') {
        field5.value = result
    }
}


function fromDurchmesser () {
    var durchmesser = field2.value
    var radius = durchmesser/2
    var height = field4.value
    var result = Math.PI * (radius*radius) * height

    result = Math.round(result*100)/100
    
    if (String(result) != 'Infinity' && String(result) != 'NaN') {
        field5.value = result
    }
}

function reset() {
    window.location.reload()
}

function fromGrundflaeche () {
    var grundflaeche = field3.value
    var height = field4.value
    var result = grundflaeche * height

    result = Math.round(result*100)/100
    
    if (String(result) != 'Infinity' && String(result) != 'NaN') {
        field5.value = result
    }
}

